export default __webpack_public_path__ + "static/media/popup_2.7c18015a.jpeg";